<form
  class="hobby"
  [formGroup]="form"
  (ngSubmit)="applyChanges()"
>
  @if (!editMode) {
    <div class="hobby__label">
      {{ 'userHobby.hobby' | translate }}:
    </div>
    <div class="hobby__text">
      {{ hobby || '-' }}
    </div>
  }

  @if (editMode) {
    @if (editMode) {
      <pu-text-area
        class="pu-form-container"
        [maxLength]="200"
        [rows]="4"
        formControlName="hobby"
        [label]="'userHobby.hobby' | translate"
      />
    }

    <div class="symbols-used">
      {{ 'userHobby.symbols' | translate }} {{ form.controls.hobby.value.length }}/200
    </div>
  }

  <div class="actions">
    @if (!editMode) {
      <button
        class="md:pu-button_m"
        puButton
        size="l"
        uiType="secondary"
        (click)="editMode = true"
      >
        {{ 'userHobby.editInfo' | translate }}
      </button>
    }

    @if (editMode) {
      <button
        class="md:pu-button_m"
        puButton
        size="l"
        uiType="primary"
        type="submit"
      >
        {{ 'userHobby.applyChanges' | translate }}
      </button>
    }

    @if (editMode) {
      <button
        class="md:pu-button_m"
        puButton
        size="l"
        uiType="secondary"
        (click)="cancel()"
      >
        {{ 'userHobby.cancel' | translate }}
      </button>
    }
  </div>
</form>
